export default __webpack_public_path__ + "static/media/album.bea677ef.svg";